<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()"><mat-icon>close</mat-icon></button>
<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>The page will reload when results are ready.
    You can still view previous data or return to the start page.</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</div>
